<script>
  import NavbarSuccess from "../NavbarSuccess.svelte";
  import { navigate, Link } from "svelte-routing";
  import { onMount, getContext } from "svelte";
  import { Button, Input, Spinner, Table } from "sveltestrap";
  import Icon from "svelte-awesome";
  import {
    filter as filterIcon,
    sort,
  } from "svelte-awesome/icons";
  import DataSpinner from "../Spinner.svelte";
  import SucessPTO from "../containers/SucessPTOContainer.svelte";
  import ColumnFilterModal from '../ColumnFilterModal.svelte';
  import axios from "axios";
  import { format as formatDate, parseISO, parse as parseLocal } from 'date-fns';

  export let startDate = null;
  export let endDate = null;
  export let staffId = '';
  export let teamId = '';
  export let filter = '';

  export let refreshData = false;
  $: {
    if (refreshData) {
      FetchData();
      refreshData = false;
    }
  };

  let fetching = false;
  let data = [];
  let displayedData = [];
  let filteredFields = {};
  let sortStates = {};

  let columnFilterModal = { open: () => {} };

  const { showForm } = getContext('hours');

  export function FetchData() {
    fetching = true;
    axios
      .get(`/reportapi/FetchApprovedTasks?startdate=${startDate}&enddate=${endDate}&staffid=${staffId}&teamid=${teamId}&filter=${filter}`)
      .then(function(res) {
        data = res.data || [];
        displayedData = data;
      })
      .catch(function(err) {
        console.log(err);
      })
      .finally(function () {
        fetching = false;
      });
  }

  function GetDownloadUrl() {
    return `../reportapi/GetApprovedTasks?startdate=${startDate}&enddate=${endDate}&staffid=${staffId}&teamid=${teamId}&filter=${filter}`;
  }

  function formatStatus(statusId) {
    return statusId == 100000000 ? "Waiting For Approval"
      : statusId == 100000001 ? "Approved"
      : statusId == 100000002 ? "Rejected"
      : "Not Submitted";
  }

  function updateFilters(field, value) {
    filteredFields = filteredFields || {};
    filteredFields[field] = value;
    filteredFields = filteredFields;
    displayedData = data.filter(filterData).sort((a, b) => compareFields(a, b, field));
  }

  function sortData(field) {
    sortStates[field] = !sortStates[field];
    displayedData = data.filter(filterData).sort((a, b) => compareFields(a, b, field));
  }

  function compareFields(a, b, fieldName) {
    // Use toUpperCase() to ignore character casing
    const lhs = `${a[fieldName]}`.toUpperCase();
    const rhs = `${b[fieldName]}`.toUpperCase();

    const comparison = lhs > rhs ? 1
      : lhs < rhs ? -1
      : 0;

    return sortStates[fieldName] ? comparison : comparison * -1;
  }

  function filterData(item) {
    let isMatch = true;

    for (const key in filteredFields) {
      if (filteredFields.hasOwnProperty(key)) {
        const searchTerm = (filteredFields[key] || '').toLowerCase();

        let fieldRawValue = '';
        switch (key) {
          case 'Status':
            fieldRawValue = !!`${item[key]}` ? formatStatus(item[key]) : '';
            break;

          default:
            fieldRawValue = item[key] || '';
            break;
        }

        const fieldValue = fieldRawValue.toString().toLowerCase();

        isMatch = isMatch && fieldValue.includes(searchTerm);
      }
    }

    return isMatch;
  }

  function showColumnFilterModal(field, value) {
    columnFilterModal.show(field, value, filteredFields[field]);
  }

  function parseDate(date, dateFormat = 'M/d/yyyy h:mm:ss aa') {
    return !!date ? formatDate(parseISO(date), dateFormat) : 'N/A';
  }

  function parseDateLocal(date, dateFormat = 'M/d/yyyy h:mm:ss aa') {
    return !!date ? formatDate(parseISO(date.slice(0, -1)), dateFormat) : 'N/A';
  }

</script>

<style>
  input {
    width: 100%;
    padding: 10px;
    border-radius: 5px;
  }
  select {
    width: 50%;
    padding: 10px;
    border-radius: 5px;
  }
  .row {
    margin: 15px 0px;
  }
  button {
    padding: 10px 5px;
    border-radius: 5px;
    background-color: #3498db;
    color: white;
  }

  th {
    background-color: #223646;
    color: white;
  }
  .header-label {
    cursor: pointer;
  }

  .request-pto-list {
    width: 100%;
    overflow: auto;
    padding: 0px 30px;
  }
  .request-row {
    display: flex;
    flex-direction: column;
  }

  .no-result-container {
    text-align: center;
  }

  .res-view-title {
    display: none;
  }
  @media (max-width: 768px) {
    .request-row {
      display: unset;
    }
    .request-pto-list {
      width: 100%;
      padding: 0px;
      border: 1px solid #ced4da;
      height: 450px;
      overflow: auto;
      margin-bottom: 30px;
    }
    .res-view-title {
      display: block;
    }
  }
</style>

<div class="timesite-container">
  <div style="display: flex; justify-content: space-between; padding: 0px 30px 10px 30px;">
    <button class="btn-flat" on:click={showForm}>
      <span class="fa fa-arrow-left"></span> Back
    </button>
    <a href={GetDownloadUrl()}>
      <button class="btn-flat {!startDate || !endDate ? 'disabled' : ''}">
        <span class="fa fa-download"></span> Download
      </button>
    </a>
  </div>
  <div class="request-row">
    {#if fetching}
      <DataSpinner />
    {:else}
      <div class="request-pto-list">
        <Table responsive bordered>
          <thead>
            <tr>
              <th>
                <span class="header-label" on:click={() => sortData('TeamName')}>
                  Team Name
                  <Icon data={sort} />
                </span>
                <span on:click={() => showColumnFilterModal('TeamName', 'Team Name')}>
                  <Icon data={filterIcon} style="color: {!!filteredFields['TeamName'] ? '#007bff' : 'inherit'};" />
                </span>
              </th>
              <th>
                <span class="header-label" on:click={() => sortData('EmployeeName')}>
                  Employee Name
                  <Icon data={sort} />
                </span>
                <span on:click={() => showColumnFilterModal('EmployeeName', 'Employee Name')}>
                  <Icon data={filterIcon} style="color: {!!filteredFields['EmployeeName'] ? '#007bff' : 'inherit'};" />
                </span>
              </th>
              <th>
                <span class="header-label" on:click={() => sortData('Date')}>
                  Date
                  <Icon data={sort} />
                </span>
                <span on:click={() => showColumnFilterModal('Date', 'Date')}>
                  <Icon data={filterIcon} style="color: {!!filteredFields['Date'] ? '#007bff' : 'inherit'};" />
                </span>
              </th>
              <th>
                <span class="header-label" on:click={() => sortData('Hours')}>
                  Hours
                  <Icon data={sort} />
                </span>
                <span on:click={() => showColumnFilterModal('Hours', 'Hours')}>
                  <Icon data={filterIcon} style="color: {!!filteredFields['Hours'] ? '#007bff' : 'inherit'};" />
                </span>
              </th>
              <th>
                <span class="header-label" on:click={() => sortData('Job')}>
                  Job
                  <Icon data={sort} />
                </span>
                <span on:click={() => showColumnFilterModal('Job', 'Job')}>
                  <Icon data={filterIcon} style="color: {!!filteredFields['Job'] ? '#007bff' : 'inherit'};" />
                </span>
              </th>
              <th>
                <span class="header-label" on:click={() => sortData('Deliverable')}>
                  Deliverable
                  <Icon data={sort} />
                </span>
                <span on:click={() => showColumnFilterModal('Deliverable', 'Deliverable')}>
                  <Icon data={filterIcon} style="color: {!!filteredFields['Deliverable'] ? '#007bff' : 'inherit'};" />
                </span>
              </th>
              <th>
                <span class="header-label" on:click={() => sortData('Task')}>
                  Task
                  <Icon data={sort} />
                </span>
                <span on:click={() => showColumnFilterModal('Task', 'Task')}>
                  <Icon data={filterIcon} style="color: {!!filteredFields['Task'] ? '#007bff' : 'inherit'};" />
                </span>
              </th>
              <th>
                <span class="header-label" on:click={() => sortData('Status')}>
                  Status
                  <Icon data={sort} />
                </span>
                <span on:click={() => showColumnFilterModal('Status', 'Status')}>
                  <Icon data={filterIcon} style="color: {!!filteredFields['Status'] ? '#007bff' : 'inherit'};" />
                </span>
              </th>
              <th>
                <span class="header-label" on:click={() => sortData('DateApproved')}>
                  Date Approved
                  <Icon data={sort} />
                </span>
                <span on:click={() => showColumnFilterModal('DateApproved', 'Date Approved')}>
                  <Icon data={filterIcon} style="color: {!!filteredFields['DateApproved'] ? '#007bff' : 'inherit'};" />
                </span>
              </th>
              <th>
                <span class="header-label" on:click={() => sortData('DateModified')}>
                  Date Modified
                  <Icon data={sort} />
                </span>
                <span on:click={() => showColumnFilterModal('DateModified', 'Date Modified')}>
                  <Icon data={filterIcon} style="color: {!!filteredFields['DateModified'] ? '#007bff' : 'inherit'};" />
                </span>
              </th>
              <th>
                <span class="header-label" on:click={() => sortData('ApprovedBy')}>
                  Approved By
                  <Icon data={sort} />
                </span>
                <span on:click={() => showColumnFilterModal('ApprovedBy', 'Approved By')}>
                  <Icon data={filterIcon} style="color: {!!filteredFields['ApprovedBy'] ? '#007bff' : 'inherit'};" />
                </span>
              </th>
            </tr>
          </thead>
          <tbody>
            {#each displayedData as list}
              <tr>
                <td>
                  <span class="res-view-title">Team Name</span>
                  {list.TeamName === null ? 'N/A' : list.TeamName}
                </td>
                <td>
                  <span class="res-view-title">Employee Name</span>
                  {list.EmployeeName === null ? 'N/A' : list.EmployeeName}
                </td>
                <td>
                  <span class="res-view-title">Date</span>
                  {!list.Date ? 'N/A' : list.Date}
                </td>
                <td>
                  <span class="res-view-title">Hours</span>
                  {list.Hours === null ? 'N/A' : list.Hours}
                </td>
                <td>
                  <span class="res-view-title">Job</span>
                  {list.Job === null ? 'N/A' : list.Job}
                </td>
                <td>
                  <span class="res-view-title">Deliverable</span>
                  {list.Deliverable === null ? 'N/A' : list.Deliverable}
                </td>
                <td>
                  <span class="res-view-title">Task</span>
                  {list.Task === null ? 'N/A' : list.Task}
                </td>
                <td>
                  <span class="res-view-title">Status</span>
                  {list.Status === null ? 'N/A' : formatStatus(list.Status)}
                </td>
                <td>
                  <span class="res-view-title">Date Approved</span>
                  {!list.DateApproved ? 'N/A' : list.DateApproved}
                </td>
                <td>
                  <span class="res-view-title">Date Modified</span>
                  {!list.DateModified ? 'N/A' : list.DateModified}
                </td>
                <td>
                  <span class="res-view-title">Approved By</span>
                  {list.ApprovedBy === null ? 'N/A' : list.ApprovedBy}
                </td>
              </tr>
            {/each}
          </tbody>
        </Table>
      </div>

      {#if displayedData.length <= 0}
        <div class="no-result-container">
          No Data
        </div>
      {/if}

    {/if}
  </div>
</div>

<ColumnFilterModal bind:this={columnFilterModal} on:filter={evt => updateFilters(evt.detail.field, evt.detail.value)}></ColumnFilterModal>
